module.exports = __webpack_public_path__ + "static/img/ls11.83943e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls11.png
// module id = muLR
// module chunks = 12